module.exports = __webpack_public_path__ + "04_glasses_red.fcf0d2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer4/04_glasses_red.png
// module id = +DMJ
// module chunks = 0